var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-type-dialog-item",class:_vm.getClass,on:{"click":_vm.handleClick}},[_c('van-radio',{attrs:{"name":_vm.item.id,"disabled":_vm.item.doctorComplete}},[_c('span',{staticClass:"list-type-dialog-item--text"},[_vm._v(_vm._s(_vm.item.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }